import React from "react";

const Home = () => {
  const features = [
    {
      icon: "fa-thumbs-up",
      title: "Unlimited Access",
      description: "Access all courses and materials anytime, anywhere.",
    },
    {
      icon: "fa-users",
      title: "Expert Teachers",
      description: "Learn from experienced and certified educators.",
    },
    {
      icon: "fa-pencil",
      title: "Learn Anything",
      description: "Choose from a wide range of topics and skills.",
    },
    {
      icon: "fa-book",
      title: "Many Courses",
      description: "Browse hundreds of curated, high-quality courses.",
    },
    {
      icon: "fa-star",
      title: "Bright Future",
      description: "Gain skills that shape a successful career path.",
    },
    {
      icon: "fa-check",
      title: "Verified Course",
      description: "Enroll in courses with verified and trusted content.",
    },
  ];

  return (
    <div>
      {/* Main Slider Section */}
      <section className="w3l-main-slider banner-slider" id="home">
        <div className="owl-one owl-carousel owl-theme">
          <div className="item">
            <div className="slider-info banner-view banner-top1">
              <div className="container">
                <div className="banner-info header-hero-19">
                  {/* <p className="w3hny-tag">Quality With Integrity</p> */}
                  <h3 className="title-hero-19">
                    Present Education in beautiful way!
                  </h3>
                  <p className="w3ban-para">
                  Inspire minds through engaging, modern, and visually
                    appealing{" "}
                    <span className="w3-xtrap">educational experiences.</span>{" "}
                  </p>
                  <a
                    href="/About"
                    className="btn btn-style btn-primary mt-sm-5 mt-4"
                  >
                    Read More <i className="fas fa-angle-double-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="w3l-grids-3 py-5" id="about">
        <div className="container py-md-5 py-3">
          <div className="bottom-ab-grids align-items-center">
            <div className="w3ab-left-top">
              <h6 className="title-subw3hny mb-1">Our Info</h6>
              <h3 className="title-w3l mb-2">
                Quality Education for Every Student
              </h3>
              <p className="my-3 mb-5 px-lg-5">
                {" "}
                We believe that every student deserves access to high-quality
                education, regardless of their background or learning style. Our
                approach focuses on delivering a well-rounded curriculum, expert
                instruction, and a nurturing environment that promotes
                curiosity, creativity, and critical thinking. By fostering
                inclusivity and excellence, we ensure that each student receives
                the tools and support needed to succeed academically and
                personally.
              </p>
              <div id="small-dialog" className="zoom-anim-dialog mfp-hide">
                <iframe
                  src="assets/images/video.mp4"
                  frameBorder="0"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    height: "400px",
                  }}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>
              {/* <div className="w3l-index5 mt-3" id="video">
                <div className="position-relative">
                  <a
                    href="#small-dialog"
                    className="popup-with-zoom-anim play-view text-center position-absolute"
                  >
                    <span className="video-play-icon">
                      <span className="fa fa-play"></span>
                    </span>
                  </a>
                  <div id="small-dialog" className="zoom-anim-dialog mfp-hide">
                    <iframe
                      src="assets/images/video.mp4"
                      frameBorder="0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>

      {/* Passion Mid Section */}
      <section className="w3l-passion-mid-sec home-phny py-5">
        <div className="container py-md-5 py-3">
          <div className="container">
            <div className="row w3l-passion-mid-grids">
              <div className="col-lg-6 passion-grid-item-info pe-lg-5 mb-lg-0 mb-5">
                <h6 className="title-subw3hny mb-1">Welcome</h6>
                <h3 className="title-w3l mb-4">
                  Empowering Students to Reach Their Full Potential
                </h3>
                <p className="mt-3 pe-lg-5">
                We are committed to creating a supportive and inspiring
                  environment where students are encouraged to discover their
                  strengths, overcome challenges, and achieve excellence.
                  Through innovative teaching methods, personalized guidance,
                  and access to modern resources, we nurture not only academic
                  success but also personal growth and confidence. Our mission
                  is to equip every student with the skills, mindset, and
                  opportunities they need to thrive in an ever-changing world.
                </p>
              </div>
              <div className="col-lg-6 w3hny-passion-item">
                <div className="row">
                  <div className="col-6 passion-grid-item-pic">
                    <img
                      src="assets/images/1.png"
                      alt=""
                      className="img-fluid radius-image"
                    />
                  </div>
                  <div className="col-6 passion-grid-item-pic">
                    <img
                      src="assets/images/22.jpg"
                      alt=""
                      className="img-fluid radius-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="w3l-features py-5" id="work">
        <div className="container py-lg-5 py-md-4 py-2">
          <div className="title-content text-center mb-lg-3 mb-4">
            <h3 className="title-w3l">You Can learn anything</h3>

            <p className="mt-3 pe-lg-5">
              {" "}
              Unlock your potential with limitless learning opportunities
              anytime, anywhere.{" "}
            </p>
          </div>
          <div className="main-cont-wthree-2">
            <div className="row justify-content-center">
              {features.map((feature, index) => (
                <div className="col-lg-4 col-md-6 mt-lg-5 mt-4" key={index}>
                  <div className="grids-1 box-wrap">
                    <div className="icon">
                      <i className={`fas ${feature.icon}`}></i>
                    </div>
                    <h4>
                      <a href="#service" className="title-head mb-3">
                        {feature.title}
                      </a>
                    </h4>
                    <p className="text-para">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="w3l-gallery" id="gallery">
        <div className="destionation-innf py-5">
          <div className="container py-lg-5 py-md-4 py-2 HomePageGallery">
            <div className="title-content text-center">
              <h6 className="title-subw3hny text-center">Gallery</h6>
              <h3 className="title-w3l mb-5 text-center">Our School</h3>
            </div>
            <ul className="gallery_agile">
              {/* Gallery Item Example */}
              {["sidhhartha1", "siddhartha", "siddharthaschool3"].map((image, index) => (
                <li key={index}>
                  <div className="w3_agile_portfolio_grid">
                    <a href={`assets/images/${image}.jpg`}>
                      <a href={`assets/images/${image}.jpg`}></a>
                      <img
                        src={`assets/images/${image}.jpg`}
                        alt=" "
                        className="img-fluid radius-image"
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "250px",
                        }}
                      />
                      <div className="w3layouts_news_grid_pos">
                        <div className="wthree_text">
                          <h3>School</h3>
                          {/* <p>Lorem Ipsum</p>*/}
                        </div>
                      </div>
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Passion Mid Section */}
      <section className="w3l-passion-mid-sec py-5">
        <div className="container py-md-5 py-3">
          <div className="container">
            <div className="row w3l-passion-mid-grids">
              <div className="col-lg-6 passion-grid-item-info pe-lg-5 mb-lg-0 mb-5">
                <h6 className="title-subw3hny mb-1">What We Offer</h6>
                <h3 className="title-w3l mb-4">
                  Explore a wide range of academic programs, extracurricular
                  activities, and student support services.
                </h3>
                <p className="mt-3 pe-lg-5">
                  Discover endless opportunities to learn, grow, and thrive both
                  inside and outside the classroom. Our well-rounded offerings
                  are designed to support every aspect of a student’s journey.
                </p>
              </div>
              <div className="col-lg-6 w3hny-passion-item">
                <div className="row">
                  <div className="col-6 passion-grid-item-pic">
                    <img
                      src="assets/images/1.png"
                      alt=""
                      className="img-fluid radius-image"
                    />
                  </div>
                  <div className="col-6 passion-grid-item-pic">
                    <img
                      src="assets/images/22.jpg"
                      alt=""
                      className="img-fluid radius-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
